import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import Masonry from "react-masonry-css";
import ShopSkeleton from "./ShopSkeleton";

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const { pathname } = useLocation();
  const url = pathname?.split("/")[2]; // category slug

  useEffect(() => {
    setLoading(true);

    const apiUrl = url
      ? `https://admin.tulikaarts.in/api/products/${url}`
      : `https://admin.tulikaarts.in/api/shop-product`;

    axios
      .get(apiUrl)
      .then((res) => {
        setProducts(res.data?.products || []);
      })
      .finally(() => setLoading(false));
  }, [url]);

  const productList = useMemo(() => products, [products]);

  const breakpointColumnsObj = {
    default: 4,
    1200: 3,
    900: 2,
    600: 1,
  };

  return (
    <div className="container shop-page py-5">
      <h1 className="text-center mb-5">Vibrant Art by Tulika</h1>

      {/* Loading State */}
      {loading ? (
        <ShopSkeleton />
      ) : productList.length === 0 ? (
        // ❌ No Products Found
        <div className="text-center py-5">
          <h2 className="text-muted">No Products Found</h2>
        </div>
      ) : (
        // ✔ Data Found → Show Products
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {productList.map((p) => (
            <div key={p.id} className="masonry-item p-2">
              <div className="card border-0 shadow-sm rounded-3 overflow-hidden">

                <Link to={`/painting/${p.product_url}`}>
                  <img
                    src={p.product_image}
                    alt={p.product_name}
                    className="img-fluid"
                    loading="lazy"
                  />
                </Link>

                <div className="card-body">
                  <h5 className="fw-bold mb-3">{p.product_name}</h5>

                  <div className="d-flex justify-content-between">
                    <p className="mb-0 text-muted">
                      <b>Size:</b> {p.product_size}
                    </p>

                    <p className="mb-0 fw-bold" style={{ color: "#cc9051" }}>
                      ₹ {p.product_price}
                    </p>
                  </div>
                </div>

              </div>
            </div>
          ))}
        </Masonry>
      )}
    </div>
  );
};

export default Shop;
